import { DashboardTeacherApi } from "@/api";

export async function getTeacherUserInfo() {
  const { data } = await DashboardTeacherApi.getTeacherUserInfo();
  return data;
}

export async function getTeacherProgressInfo() {
  const { data } = await DashboardTeacherApi.getTeacherProgressInfo();
  return data;
}

export async function getTeacherSemesterInfo() {
  const { data } = await DashboardTeacherApi.getTeacherSemesterInfo();
  return data;
}

export async function getTeacherLatestTopics() {
  const { data } = await DashboardTeacherApi.getTeacherLatestTopics();
  return data;
}

export async function getTeacherCoursesInfo() {
  const { data } = await DashboardTeacherApi.getTeacherCoursesInfo();
  return data;
}

export async function getTeacherRankingInfo() {
  const { data } = await DashboardTeacherApi.getTeacherRankingInfo();
  return data;
}
